import { render, staticRenderFns } from "./UpsellPreviewModal.vue?vue&type=template&id=087f9c68&"
import script from "./UpsellPreviewModal.vue?vue&type=script&lang=ts&"
export * from "./UpsellPreviewModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpsellPreviewModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports